/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the FxIdApplicationStoreInAppSteamSteamInAppBillingData interface.
 */
export function instanceOfFxIdApplicationStoreInAppSteamSteamInAppBillingData(value) {
    if (!('OrderId' in value) || value['OrderId'] === undefined)
        return false;
    if (!('DeveloperPayload' in value) || value['DeveloperPayload'] === undefined)
        return false;
    if (!('Sku' in value) || value['Sku'] === undefined)
        return false;
    return true;
}
export function FxIdApplicationStoreInAppSteamSteamInAppBillingDataFromJSON(json) {
    return FxIdApplicationStoreInAppSteamSteamInAppBillingDataFromJSONTyped(json, false);
}
export function FxIdApplicationStoreInAppSteamSteamInAppBillingDataFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'OrderId': json['OrderId'],
        'DeveloperPayload': json['DeveloperPayload'],
        'Sku': json['Sku'],
    };
}
export function FxIdApplicationStoreInAppSteamSteamInAppBillingDataToJSON(json) {
    return FxIdApplicationStoreInAppSteamSteamInAppBillingDataToJSONTyped(json, false);
}
export function FxIdApplicationStoreInAppSteamSteamInAppBillingDataToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'OrderId': value['OrderId'],
        'DeveloperPayload': value['DeveloperPayload'],
        'Sku': value['Sku'],
    };
}
//# sourceMappingURL=FxIdApplicationStoreInAppSteamSteamInAppBillingData.js.map